var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInboxLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 16,
  viewBox: "0 0 24 16",
  fill: "#C4C4C4",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.57143 0C1.16169 0 0 1.11331 0 2.46429V13.4167C0 14.7676 1.16169 15.881 2.57143 15.881H21.4286C22.8383 15.881 24 14.7676 24 13.4167V2.46429C24 1.11331 22.8383 0 21.4286 0H2.57143ZM2.75891 1.64286H21.25L12.5268 9.10417C12.1943 9.38871 11.8244 9.38901 11.4911 9.10417L2.75891 1.64286ZM1.71429 2.95199L7.58929 7.9747L1.71429 13.3824V2.95199ZM22.2857 2.95199V13.3739L16.4286 7.96616L22.2857 2.95199ZM15.1429 9.06994L20.7411 14.2381H3.25891L8.875 9.07848L10.3482 10.3363C11.2847 11.1365 12.7331 11.1378 13.6697 10.3363L15.1429 9.06994Z",
  stroke: "none"
})));
export default SvgInboxLarge;